import { ValidatorFn, Validators } from '@angular/forms';
import { FieldDefinition } from '../../models/field-definition';

export function buildValidators(field: FieldDefinition): ValidatorFn[] {
  const validators: ValidatorFn[] = [];

  if (field.required) {
    validators.push(Validators.required);
  }
  if (field.minLength != null) {
    validators.push(Validators.minLength(field.minLength));
  }
  if (field.maxLength != null) {
    validators.push(Validators.maxLength(field.maxLength));
  }
  if (field.pattern) {
    validators.push(Validators.pattern(field.pattern));
  }
  if (field.min != null) {
    validators.push(Validators.min(field.min));
  }
  if (field.max != null) {
    validators.push(Validators.max(field.max));
  }

  return validators;
}

export function resolveErrorMessage(field: FieldDefinition, errors: Record<string, unknown> | null): string {
  if (!errors) {
    return '';
  }

  // Report the first failing rule; admin-configured text wins over the default.
  const errorKey = Object.keys(errors)[0];
  const custom = field.validationMessages?.[errorKey];
  if (custom) {
    return custom;
  }

  switch (errorKey) {
    case 'required':
      return `${field.label} is required.`;
    case 'minlength':
      return `${field.label} must be at least ${field.minLength} characters.`;
    case 'maxlength':
      return `${field.label} cannot exceed ${field.maxLength} characters.`;
    case 'pattern':
      return `${field.label} has an invalid format.`;
    case 'min':
      return `${field.label} must be at least ${field.min}.`;
    case 'max':
      return `${field.label} cannot exceed ${field.max}.`;
    default:
      return `${field.label} is invalid.`;
  }
}
